import { Directive, inject, Input, TemplateRef, ViewContainerRef } from "@angular/core";
import { RoleName } from "../classes/flow/session/Session";
import { AuthService } from "../services/auth.service";

@Directive({ selector: "[appIsRole]" })
/**
 * Structural directive to check whether the currently logged in user currently has his active role set to one of the given roles when using this directive.
 * The component on which the directive is used will be either included in the html or not, according to the previous check.
 */
export class RoleDirective {
  private template = inject<TemplateRef<unknown>>(TemplateRef);
  private container = inject(ViewContainerRef);

  private auth = inject(AuthService);

  @Input() set appIsRole(role: RoleName | RoleName[]) {
    if (Array.isArray(role) ? role.some((x) => this.hasPermission(x)) : this.hasPermission(role)) {
      this.container.createEmbeddedView(this.template);
    } else {
      this.container.clear();
    }
  }

  private hasPermission(role: RoleName) {
    if (role === "coach") return this.auth.isCoach();
    if (role === "coordinator") return this.auth.isCoordinator();
    if (role === "resident") return this.auth.isResident();
    if (role === "guest") return !this.auth.session.value;
    return false;
  }
}
